"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";
var DS = [{
  id: 'all',
  text: '(All)'
}, {
  id: 'true',
  text: 'True'
}, {
  id: 'false',
  text: 'False'
}];

var BoolTableControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(BoolTableControl, _BaseControl);

  function BoolTableControl() {
    _classCallCheck(this, BoolTableControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(BoolTableControl).apply(this, arguments));
  }

  _createClass(BoolTableControl, [{
    key: "_buildControlProps",
    value: function _buildControlProps() {
      var _this = this;

      return _objectSpread({}, _get(_getPrototypeOf(BoolTableControl.prototype), "_buildControlProps", this).call(this), {
        dataSource: DS,
        displayExpr: "text",
        valueExpr: "id",
        value: this.value == null ? 'all' : this.value.toString(),
        onValueChanged: function onValueChanged(e) {
          _this.value = e.value;

          if (typeof _this.props.onValueChanged === 'function') {
            _this.props.onValueChanged({
              value: _this.value === 'all' ? undefined : _this.value === 'true'
            });
          }
        }
      });
    }
  }, {
    key: "instance",
    value: function instance() {
      return this.$_element.dxSelectBox('instance');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.$_element.dxSelectBox('dispose');
      this.$_element.remove();
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element = this.$_element.dxSelectBox(_objectSpread({}, this._buildControlProps()));
    }
  }]);

  return BoolTableControl;
}(BaseControl);

export { BoolTableControl as default };